import BasicAlgebraLogo from '~/assets/drill/basic-algebra'
import DrillTopicListElement from '~/components/Drill/DrillTopicsList/components/DrillTopicListElement'

export default function BasicAlgebra({
  title,
  completed,
  path,
}: {
  title: string
  completed: boolean
  path: string
}): React.ReactElement {
  const gridMobile = 'row-start-9 row-end-11 col-start-1 col-end-3'
  const gridTablet = 'md:row-start-2 md:row-end-2 md:col-start-2 md:col-end-4'
  const gridDesktop = 'xl:row-start-2 xl:row-end-2 xl:col-start-6 xl:col-end-8'
  const gridClassNames = [gridMobile, gridTablet, gridDesktop].join(' ')

  return (
    <DrillTopicListElement
      completed={completed}
      gridClassNames={gridClassNames}
      image={BasicAlgebraLogo}
      imageClassNames="h-10"
      path={path}
      title={title}
    />
  )
}
